/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './root.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/intl.service';
import * as import10 from 'angular2-cookie/services/cookies.service';
import * as import11 from './cart.service';
import * as import12 from '@angular/common/src/location/location';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '@angular/router/src/router';
import * as import15 from '@angular/core/src/linker/element_ref';
import * as import16 from '../shared/utils.service';
import * as import17 from '@angular/core/src/metadata/view';
import * as import18 from '@angular/core/src/linker/component_factory';
import * as import19 from '../shared/language-routing.component.ngfactory';
import * as import20 from './cookie-consent.component.ngfactory';
import * as import21 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '../shared/notification.service';
import * as import23 from './cart-widget.component.ngfactory';
import * as import24 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import25 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import26 from '../../../node_modules/@angular/router/src/directives/router_outlet.ngfactory';
import * as import27 from '../shared/intl.pipe';
import * as import28 from '@angular/core/src/linker/template_ref';
import * as import29 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import30 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import31 from '@angular/router/src/router_outlet_map';
import * as import32 from '@angular/core/src/linker/component_factory_resolver';
import * as import33 from './cookie-consent.component';
import * as import34 from '@angular/common/src/directives/ng_if';
import * as import35 from './cart-widget.component';
import * as import36 from '@angular/common/src/directives/ng_for';
import * as import37 from '@angular/common/src/directives/ng_class';
import * as import38 from '@angular/router/src/directives/router_outlet';
import * as import39 from '../shared/language-routing.component';
import * as import40 from '../shared/loading-indicator.ngfactory';
import * as import41 from '../shared/loading-indicator';
import * as import42 from '../shared/language-selector.component.ngfactory';
import * as import43 from '../shared/language-selector.component';
export class Wrapper_FrontRootComponent {
  context:import0.FrontRootComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any) {
    this.changed = false;
    this.context = new import0.FrontRootComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_FrontRootComponent_Host:import2.RenderComponentType = (null as any);
class _View_FrontRootComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _FrontRootComponent_0_4:Wrapper_FrontRootComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_FrontRootComponent_Host0,renderType_FrontRootComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_FrontRootComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._FrontRootComponent_0_4 = new Wrapper_FrontRootComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.IntlService),this.parentInjector.get(import10.CookieService),this.parentInjector.get(import11.CartService),this.parentInjector.get(import12.Location),this.parentInjector.get(import13.ActivatedRoute),this.parentInjector.get(import14.Router),new import15.ElementRef(this._el_0),this.renderer,this.parentInjector.get(import16.UtilsService));
    this._appEl_0.initComponent(this._FrontRootComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._FrontRootComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.FrontRootComponent) && (0 === requestNodeIndex))) { return this._FrontRootComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._FrontRootComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FrontRootComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._FrontRootComponent_0_4.context.ngAfterViewInit(); } }
  }
}
function viewFactory_FrontRootComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_FrontRootComponent_Host === (null as any))) { (renderType_FrontRootComponent_Host = viewUtils.createRenderComponentType('',0,import17.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_FrontRootComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const FrontRootComponentNgFactory:import18.ComponentFactory<import0.FrontRootComponent> = new import18.ComponentFactory<import0.FrontRootComponent>('ng-component',viewFactory_FrontRootComponent_Host0,import0.FrontRootComponent);
const styles_FrontRootComponent:any[] = ([] as any[]);
var renderType_FrontRootComponent:import2.RenderComponentType = (null as any);
class _View_FrontRootComponent0 extends import1.AppView<import0.FrontRootComponent> {
  _text_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _LanguageRoutingComponent_3_3:import19.Wrapper_LanguageRoutingComponent;
  _text_4:any;
  _el_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _CookieConsentComponent_5_4:import20.Wrapper_CookieConsentComponent;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  _anchor_34:any;
  /*private*/ _appEl_34:import3.AppElement;
  _TemplateRef_34_5:any;
  _NgIf_34_6:import21.Wrapper_NgIf;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _el_47:any;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  /*private*/ _appEl_53:import3.AppElement;
  _NotificationService_53_4:import22.NotificationService;
  _CartWidgetComponent_53_5:import23.Wrapper_CartWidgetComponent;
  _text_54:any;
  _text_55:any;
  _el_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _anchor_60:any;
  /*private*/ _appEl_60:import3.AppElement;
  _TemplateRef_60_5:any;
  _NgFor_60_6:import24.Wrapper_NgFor;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _appEl_65:import3.AppElement;
  _TemplateRef_65_5:any;
  _NgFor_65_6:import24.Wrapper_NgFor;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _text_69:any;
  _text_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _text_78:any;
  _el_79:any;
  _text_80:any;
  _el_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _text_85:any;
  _text_86:any;
  _text_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _el_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _el_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _text_99:any;
  _text_100:any;
  _text_101:any;
  _el_102:any;
  _NgClass_102_3:import25.Wrapper_NgClass;
  _text_103:any;
  _el_104:any;
  _text_105:any;
  _text_106:any;
  _text_107:any;
  _text_108:any;
  _el_109:any;
  _NgClass_109_3:import25.Wrapper_NgClass;
  _text_110:any;
  _el_111:any;
  _text_112:any;
  _text_113:any;
  _text_114:any;
  _el_115:any;
  _NgClass_115_3:import25.Wrapper_NgClass;
  _text_116:any;
  _el_117:any;
  _text_118:any;
  _text_119:any;
  _text_120:any;
  _text_121:any;
  _text_122:any;
  _text_123:any;
  _text_124:any;
  _text_125:any;
  _text_126:any;
  _text_127:any;
  _text_128:any;
  _el_129:any;
  /*private*/ _appEl_129:import3.AppElement;
  _RouterOutlet_129_5:import26.Wrapper_RouterOutlet;
  _text_130:any;
  _text_131:any;
  _el_132:any;
  _text_133:any;
  _el_134:any;
  _text_135:any;
  _el_136:any;
  _text_137:any;
  _el_138:any;
  _text_139:any;
  _el_140:any;
  _el_141:any;
  _text_142:any;
  _el_143:any;
  _el_144:any;
  _text_145:any;
  _text_146:any;
  _text_147:any;
  _el_148:any;
  _el_149:any;
  _text_150:any;
  _el_151:any;
  _el_152:any;
  _text_153:any;
  _text_154:any;
  _text_155:any;
  _el_156:any;
  _el_157:any;
  _text_158:any;
  _el_159:any;
  _el_160:any;
  _text_161:any;
  _text_162:any;
  _text_163:any;
  _text_164:any;
  _text_165:any;
  _text_166:any;
  _el_167:any;
  _text_168:any;
  _el_169:any;
  _text_170:any;
  _el_171:any;
  _text_172:any;
  _text_173:any;
  _el_174:any;
  _text_175:any;
  _text_176:any;
  _text_177:any;
  _text_178:any;
  _el_179:any;
  _text_180:any;
  _el_181:any;
  _text_182:any;
  _el_183:any;
  _text_184:any;
  _text_185:any;
  _el_186:any;
  _text_187:any;
  _el_188:any;
  _text_189:any;
  _text_190:any;
  _text_191:any;
  _text_192:any;
  _text_193:any;
  _text_194:any;
  _text_195:any;
  _text_196:any;
  _text_197:any;
  _text_198:any;
  _el_199:any;
  _el_200:any;
  _text_201:any;
  _text_202:any;
  _text_203:any;
  _text_204:any;
  /*private*/ _expr_225:any;
  _pipe_intl_0:import27.IntlPipe;
  _pipe_intl_0_0:any;
  _map_228:any;
  /*private*/ _expr_229:any;
  _pipe_intl_0_1:any;
  _map_231:any;
  /*private*/ _expr_232:any;
  _pipe_intl_0_2:any;
  _map_234:any;
  /*private*/ _expr_235:any;
  _pipe_intl_0_3:any;
  /*private*/ _expr_237:any;
  /*private*/ _expr_238:any;
  _pipe_intl_0_4:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_FrontRootComponent0,renderType_FrontRootComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_225 = import7.UNINITIALIZED;
    this._map_228 = import4.pureProxy1((p0:any):{[key: string]:any} => {
      return {current: p0};
    });
    this._expr_229 = import7.UNINITIALIZED;
    this._map_231 = import4.pureProxy1((p0:any):{[key: string]:any} => {
      return {current: p0};
    });
    this._expr_232 = import7.UNINITIALIZED;
    this._map_234 = import4.pureProxy1((p0:any):{[key: string]:any} => {
      return {current: p0};
    });
    this._expr_235 = import7.UNINITIALIZED;
    this._expr_237 = import7.UNINITIALIZED;
    this._expr_238 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._text_2 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,parentRenderNode,'span',new import4.InlineArray2(2,'lg-routing',''),(null as any));
    this._LanguageRoutingComponent_3_3 = new import19.Wrapper_LanguageRoutingComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import12.Location),this.parentInjector.get(import14.Router),this.parentInjector.get(import16.UtilsService),this.parentInjector.get(import10.CookieService));
    this._text_4 = this.renderer.createText(this._el_3,'\n\n',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_3,'policy-checker',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_5 = new import3.AppElement(5,3,this,this._el_5);
    var compView_5:any = import20.viewFactory_CookieConsentComponent0(this.viewUtils,this.injector(5),this._appEl_5);
    this._CookieConsentComponent_5_4 = new import20.Wrapper_CookieConsentComponent(this.parentInjector.get(import9.IntlService),this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import16.UtilsService),this.parentInjector.get(import10.CookieService),this.renderer,new import15.ElementRef(this._el_5));
    this._appEl_5.initComponent(this._CookieConsentComponent_5_4.context,([] as any[]),compView_5);
    compView_5.create(this._CookieConsentComponent_5_4.context,([] as any[]),(null as any));
    this._text_6 = this.renderer.createText(this._el_3,'\n\n',(null as any));
    this._el_7 = import4.createRenderElement(this.renderer,this._el_3,'nav',new import4.InlineArray4(4,'class','navbar navbar-default navbar-fixed-top nav-transparent overlay-nav sticky-nav nav-white nav-border-bottom','role','navigation'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n    ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_7,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n        ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_11,'   \n            ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_11,'div',new import4.InlineArray2(2,'class','col-md-1 pull-left'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._el_16 = import4.createRenderElement(this.renderer,this._el_14,'a',new import4.InlineArray2(2,'class','pointer logo-light text-small font-weight-600 text-uppercase white-text letter-spacing-7'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                    ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_16,'span',new import4.InlineArray2(2,'class','logo-first-letter'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'F',(null as any));
    this._text_20 = this.renderer.createText(this._el_16,'orgotten',(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_16,'br',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_16,' Records\n                    ',(null as any));
    this._text_23 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_24 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._el_25 = import4.createRenderElement(this.renderer,this._el_14,'a',new import4.InlineArray2(2,'class','logo-dark text-small font-weight-600 text-uppercase black-text letter-spacing-7'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                    ',(null as any));
    this._el_27 = import4.createRenderElement(this.renderer,this._el_25,'span',new import4.InlineArray2(2,'class','logo-first-letter'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'F',(null as any));
    this._text_29 = this.renderer.createText(this._el_25,'orgotten',(null as any));
    this._el_30 = import4.createRenderElement(this.renderer,this._el_25,'br',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_31 = this.renderer.createText(this._el_25,' Records\n                    ',(null as any));
    this._text_32 = this.renderer.createText(this._el_25,'\n                ',(null as any));
    this._text_33 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._anchor_34 = this.renderer.createTemplateAnchor(this._el_14,(null as any));
    this._appEl_34 = new import3.AppElement(34,14,this,this._anchor_34);
    this._TemplateRef_34_5 = new import28.TemplateRef_(this._appEl_34,viewFactory_FrontRootComponent1);
    this._NgIf_34_6 = new import21.Wrapper_NgIf(this._appEl_34.vcRef,this._TemplateRef_34_5);
    this._text_35 = this.renderer.createText(this._el_14,'\n            ',(null as any));
    this._text_36 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_37 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_38 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_39 = import4.createRenderElement(this.renderer,this._el_11,'div',new import4.InlineArray2(2,'class','col-md-3 no-padding-left search-cart-header pull-right'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'\n                ',(null as any));
    this._el_41 = import4.createRenderElement(this.renderer,this._el_39,'div',new import4.InlineArray2(2,'id','top-search'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._text_43 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._text_44 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._text_45 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._el_46 = import4.createRenderElement(this.renderer,this._el_41,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._el_47 = import4.createRenderElement(this.renderer,this._el_46,'i',new import4.InlineArray2(2,'class','fa fa-search search-button'),(null as any));
    this._text_48 = this.renderer.createText(this._el_41,'\n                ',(null as any));
    this._text_49 = this.renderer.createText(this._el_39,'\n                ',(null as any));
    this._text_50 = this.renderer.createText(this._el_39,'\n                ',(null as any));
    this._text_51 = this.renderer.createText(this._el_39,'\n\n                ',(null as any));
    this._text_52 = this.renderer.createText(this._el_39,'\n                ',(null as any));
    this._el_53 = import4.createRenderElement(this.renderer,this._el_39,'cart-widget',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_53 = new import3.AppElement(53,39,this,this._el_53);
    var compView_53:any = import23.viewFactory_CartWidgetComponent0(this.viewUtils,this.injector(53),this._appEl_53);
    this._NotificationService_53_4 = new import22.NotificationService(new import15.ElementRef(this._el_53),this.renderer);
    this._CartWidgetComponent_53_5 = new import23.Wrapper_CartWidgetComponent(this._NotificationService_53_4,this.parentInjector.get(import9.IntlService),this.parentInjector.get(import16.UtilsService),this.parentInjector.get(import11.CartService),this.parentInjector.get(import13.ActivatedRoute),this.parentInjector.get(import14.Router));
    this._appEl_53.initComponent(this._CartWidgetComponent_53_5.context,([] as any[]),compView_53);
    this._text_54 = this.renderer.createText((null as any),'\n                ',(null as any));
    compView_53.create(this._CartWidgetComponent_53_5.context,([] as any[]),(null as any));
    this._text_55 = this.renderer.createText(this._el_39,'\n\n                ',(null as any));
    this._el_56 = import4.createRenderElement(this.renderer,this._el_39,'div',new import4.InlineArray2(2,'class','language-selector pull-right'),(null as any));
    this._text_57 = this.renderer.createText(this._el_56,'\n                    ',(null as any));
    this._el_58 = import4.createRenderElement(this.renderer,this._el_56,'div',new import4.InlineArray2(2,'class','logo-light'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'\n                        ',(null as any));
    this._anchor_60 = this.renderer.createTemplateAnchor(this._el_58,(null as any));
    this._appEl_60 = new import3.AppElement(60,58,this,this._anchor_60);
    this._TemplateRef_60_5 = new import28.TemplateRef_(this._appEl_60,viewFactory_FrontRootComponent2);
    this._NgFor_60_6 = new import24.Wrapper_NgFor(this._appEl_60.vcRef,this._TemplateRef_60_5,this.parentInjector.get(import29.IterableDiffers),this.ref);
    this._text_61 = this.renderer.createText(this._el_58,'\n                    ',(null as any));
    this._text_62 = this.renderer.createText(this._el_56,'\n                    ',(null as any));
    this._el_63 = import4.createRenderElement(this.renderer,this._el_56,'div',new import4.InlineArray2(2,'class','logo-dark'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n                        ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_63,(null as any));
    this._appEl_65 = new import3.AppElement(65,63,this,this._anchor_65);
    this._TemplateRef_65_5 = new import28.TemplateRef_(this._appEl_65,viewFactory_FrontRootComponent3);
    this._NgFor_65_6 = new import24.Wrapper_NgFor(this._appEl_65.vcRef,this._TemplateRef_65_5,this.parentInjector.get(import29.IterableDiffers),this.ref);
    this._text_66 = this.renderer.createText(this._el_63,'\n                    ',(null as any));
    this._text_67 = this.renderer.createText(this._el_56,'\n                ',(null as any));
    this._text_68 = this.renderer.createText(this._el_39,'\n\n            ',(null as any));
    this._text_69 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_70 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_71 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_72 = import4.createRenderElement(this.renderer,this._el_11,'div',new import4.InlineArray2(2,'class','navbar-header col-xs-2 pull-right'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                ',(null as any));
    this._el_74 = import4.createRenderElement(this.renderer,this._el_72,'button',new import4.InlineArray16(10,'class','navbar-toggle','data-target','.navbar-collapse','data-toggle','collapse','id','accordion-menu','type','button'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,' ',(null as any));
    this._el_76 = import4.createRenderElement(this.renderer,this._el_74,'span',new import4.InlineArray2(2,'class','sr-only'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'Toggle navigation',(null as any));
    this._text_78 = this.renderer.createText(this._el_74,' ',(null as any));
    this._el_79 = import4.createRenderElement(this.renderer,this._el_74,'span',new import4.InlineArray2(2,'class','icon-bar'),(null as any));
    this._text_80 = this.renderer.createText(this._el_74,' ',(null as any));
    this._el_81 = import4.createRenderElement(this.renderer,this._el_74,'span',new import4.InlineArray2(2,'class','icon-bar'),(null as any));
    this._text_82 = this.renderer.createText(this._el_74,' ',(null as any));
    this._el_83 = import4.createRenderElement(this.renderer,this._el_74,'span',new import4.InlineArray2(2,'class','icon-bar'),(null as any));
    this._text_84 = this.renderer.createText(this._el_74,' ',(null as any));
    this._text_85 = this.renderer.createText(this._el_72,'\n            ',(null as any));
    this._text_86 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_87 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_88 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_89 = import4.createRenderElement(this.renderer,this._el_11,'div',new import4.InlineArray2(2,'class','col-md-8 no-padding-right accordion-menu text-right'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n                ',(null as any));
    this._el_91 = import4.createRenderElement(this.renderer,this._el_89,'div',new import4.InlineArray2(2,'class','navbar-collapse collapse'),(null as any));
    this._text_92 = this.renderer.createText(this._el_91,'\n                    ',(null as any));
    this._el_93 = import4.createRenderElement(this.renderer,this._el_91,'ul',new import4.InlineArray4(4,'class','nav navbar-nav navbar-right panel-group','id','accordion'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'\n                        \n                        ',(null as any));
    this._el_95 = import4.createRenderElement(this.renderer,this._el_93,'li',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_96 = this.renderer.createText(this._el_95,'\n                            ',(null as any));
    this._el_97 = import4.createRenderElement(this.renderer,this._el_95,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_98 = this.renderer.createText(this._el_97,'',(null as any));
    this._text_99 = this.renderer.createText(this._el_95,'\n                        ',(null as any));
    this._text_100 = this.renderer.createText(this._el_93,'\n\n                        ',(null as any));
    this._text_101 = this.renderer.createText(this._el_93,'\n                        ',(null as any));
    this._el_102 = import4.createRenderElement(this.renderer,this._el_93,'li',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._NgClass_102_3 = new import25.Wrapper_NgClass(this.parentInjector.get(import29.IterableDiffers),this.parentInjector.get(import30.KeyValueDiffers),new import15.ElementRef(this._el_102),this.renderer);
    this._text_103 = this.renderer.createText(this._el_102,'\n                            ',(null as any));
    this._el_104 = import4.createRenderElement(this.renderer,this._el_102,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_105 = this.renderer.createText(this._el_104,'',(null as any));
    this._text_106 = this.renderer.createText(this._el_102,' \n                            ',(null as any));
    this._text_107 = this.renderer.createText(this._el_102,'\n                        ',(null as any));
    this._text_108 = this.renderer.createText(this._el_93,'\n                        \n                        ',(null as any));
    this._el_109 = import4.createRenderElement(this.renderer,this._el_93,'li',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._NgClass_109_3 = new import25.Wrapper_NgClass(this.parentInjector.get(import29.IterableDiffers),this.parentInjector.get(import30.KeyValueDiffers),new import15.ElementRef(this._el_109),this.renderer);
    this._text_110 = this.renderer.createText(this._el_109,'\n                            ',(null as any));
    this._el_111 = import4.createRenderElement(this.renderer,this._el_109,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_112 = this.renderer.createText(this._el_111,'',(null as any));
    this._text_113 = this.renderer.createText(this._el_109,'                             \n                        ',(null as any));
    this._text_114 = this.renderer.createText(this._el_93,'\n\n                        ',(null as any));
    this._el_115 = import4.createRenderElement(this.renderer,this._el_93,'li',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._NgClass_115_3 = new import25.Wrapper_NgClass(this.parentInjector.get(import29.IterableDiffers),this.parentInjector.get(import30.KeyValueDiffers),new import15.ElementRef(this._el_115),this.renderer);
    this._text_116 = this.renderer.createText(this._el_115,'\n                            ',(null as any));
    this._el_117 = import4.createRenderElement(this.renderer,this._el_115,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_118 = this.renderer.createText(this._el_117,'',(null as any));
    this._text_119 = this.renderer.createText(this._el_115,'                            \n                        ',(null as any));
    this._text_120 = this.renderer.createText(this._el_93,'\n                        \n                    ',(null as any));
    this._text_121 = this.renderer.createText(this._el_91,'\n                ',(null as any));
    this._text_122 = this.renderer.createText(this._el_89,'\n            ',(null as any));
    this._text_123 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_124 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._text_125 = this.renderer.createText(this._el_9,'\n    ',(null as any));
    this._text_126 = this.renderer.createText(this._el_7,'\n',(null as any));
    this._text_127 = this.renderer.createText(this._el_3,'\n',(null as any));
    this._text_128 = this.renderer.createText(this._el_3,'\n\n',(null as any));
    this._el_129 = import4.createRenderElement(this.renderer,this._el_3,'router-outlet',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_129 = new import3.AppElement(129,3,this,this._el_129);
    this._RouterOutlet_129_5 = new import26.Wrapper_RouterOutlet(this.parentInjector.get(import31.RouterOutletMap),this._appEl_129.vcRef,this.parentInjector.get(import32.ComponentFactoryResolver),(null as any));
    this._text_130 = this.renderer.createText(this._el_3,'\n\n',(null as any));
    this._text_131 = this.renderer.createText(this._el_3,'\n',(null as any));
    this._el_132 = import4.createRenderElement(this.renderer,this._el_3,'footer',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_133 = this.renderer.createText(this._el_132,'\n    ',(null as any));
    this._el_134 = import4.createRenderElement(this.renderer,this._el_132,'div',new import4.InlineArray2(2,'class','bg-gray footer-top'),(null as any));
    this._text_135 = this.renderer.createText(this._el_134,'\n        ',(null as any));
    this._el_136 = import4.createRenderElement(this.renderer,this._el_134,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_137 = this.renderer.createText(this._el_136,'\n            ',(null as any));
    this._el_138 = import4.createRenderElement(this.renderer,this._el_136,'div',new import4.InlineArray2(2,'class','row margin-four center-col text-center'),(null as any));
    this._text_139 = this.renderer.createText(this._el_138,'\n\n                ',(null as any));
    this._el_140 = import4.createRenderElement(this.renderer,this._el_138,'div',new import4.InlineArray2(2,'class','col-sm-4 text-center'),(null as any));
    this._el_141 = import4.createRenderElement(this.renderer,this._el_140,'i',new import4.InlineArray2(2,'class','fa fa-facebook small-icon black-text'),(null as any));
    this._text_142 = this.renderer.createText(this._el_140,'\n                    ',(null as any));
    this._el_143 = import4.createRenderElement(this.renderer,this._el_140,'h6',new import4.InlineArray2(2,'class','margin-two no-margin-bottom'),(null as any));
    this._el_144 = import4.createRenderElement(this.renderer,this._el_143,'a',new import4.InlineArray8(6,'class','black-text','href','http://facebook.com/forgottenrecords','target','_blank'),(null as any));
    this._text_145 = this.renderer.createText(this._el_144,'fb.com/forgottenrecords',(null as any));
    this._text_146 = this.renderer.createText(this._el_140,'\n                ',(null as any));
    this._text_147 = this.renderer.createText(this._el_138,'\n\n                ',(null as any));
    this._el_148 = import4.createRenderElement(this.renderer,this._el_138,'div',new import4.InlineArray2(2,'class','col-sm-4 text-center'),(null as any));
    this._el_149 = import4.createRenderElement(this.renderer,this._el_148,'i',new import4.InlineArray2(2,'class','icon-envelope small-icon black-text'),(null as any));
    this._text_150 = this.renderer.createText(this._el_148,'\n                    ',(null as any));
    this._el_151 = import4.createRenderElement(this.renderer,this._el_148,'h6',new import4.InlineArray2(2,'class','margin-two no-margin-bottom contact'),(null as any));
    this._el_152 = import4.createRenderElement(this.renderer,this._el_151,'a',new import4.InlineArray4(4,'class','black-text','href','mailto:contact@forgottenrecords.com'),(null as any));
    this._text_153 = this.renderer.createText(this._el_152,'contact@forgottenrecords.com',(null as any));
    this._text_154 = this.renderer.createText(this._el_148,'\n                ',(null as any));
    this._text_155 = this.renderer.createText(this._el_138,'\n\n                ',(null as any));
    this._el_156 = import4.createRenderElement(this.renderer,this._el_138,'div',new import4.InlineArray2(2,'class','col-sm-4 text-center'),(null as any));
    this._el_157 = import4.createRenderElement(this.renderer,this._el_156,'i',new import4.InlineArray2(2,'class','fa fa-instagram small-icon black-text'),(null as any));
    this._text_158 = this.renderer.createText(this._el_156,'\n                    ',(null as any));
    this._el_159 = import4.createRenderElement(this.renderer,this._el_156,'h6',new import4.InlineArray2(2,'class','black-text margin-two no-margin-bottom'),(null as any));
    this._el_160 = import4.createRenderElement(this.renderer,this._el_159,'a',new import4.InlineArray8(6,'class','black-text','href','http://instagram.com/forgottenrecords','target','_blank'),(null as any));
    this._text_161 = this.renderer.createText(this._el_160,'instagr.am/forgottenrecords',(null as any));
    this._text_162 = this.renderer.createText(this._el_156,'\n                ',(null as any));
    this._text_163 = this.renderer.createText(this._el_138,'\n            ',(null as any));
    this._text_164 = this.renderer.createText(this._el_136,' \n        ',(null as any));
    this._text_165 = this.renderer.createText(this._el_134,'\n    ',(null as any));
    this._text_166 = this.renderer.createText(this._el_132,'\n\n    ',(null as any));
    this._el_167 = import4.createRenderElement(this.renderer,this._el_132,'div',new import4.InlineArray2(2,'class','container-fluid bg-dark-gray footer-bottom'),(null as any));
    this._text_168 = this.renderer.createText(this._el_167,'\n        ',(null as any));
    this._el_169 = import4.createRenderElement(this.renderer,this._el_167,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_170 = this.renderer.createText(this._el_169,'\n            ',(null as any));
    this._el_171 = import4.createRenderElement(this.renderer,this._el_169,'div',new import4.InlineArray2(2,'class','row margin-three'),(null as any));
    this._text_172 = this.renderer.createText(this._el_171,'\n                ',(null as any));
    this._text_173 = this.renderer.createText(this._el_171,'\n                ',(null as any));
    this._el_174 = import4.createRenderElement(this.renderer,this._el_171,'div',new import4.InlineArray2(2,'class','col-lg-8 col-sm-6 copyright text-left letter-spacing-1 xs-text-center xs-margin-bottom-one'),(null as any));
    this._text_175 = this.renderer.createText(this._el_174,'',(null as any));
    this._text_176 = this.renderer.createText(this._el_171,'\n                ',(null as any));
    this._text_177 = this.renderer.createText(this._el_171,'\n                ',(null as any));
    this._text_178 = this.renderer.createText(this._el_171,'\n                ',(null as any));
    this._el_179 = import4.createRenderElement(this.renderer,this._el_171,'div',new import4.InlineArray2(2,'class','col-lg-4 col-sm-6 footer-logo deep-light-gray-text'),(null as any));
    this._text_180 = this.renderer.createText(this._el_179,'\n                    4 allée du Clos Pilet, 35700 Rennes, France',(null as any));
    this._el_181 = import4.createRenderElement(this.renderer,this._el_179,'br',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_182 = this.renderer.createText(this._el_179,'\n                    ',(null as any));
    this._el_183 = import4.createRenderElement(this.renderer,this._el_179,'a',new import4.InlineArray4(4,'class','light-gray-text','href','mailto:contact@forgottenrecords.com'),(null as any));
    this._text_184 = this.renderer.createText(this._el_183,'contact@forgottenrecords.com',(null as any));
    this._text_185 = this.renderer.createText(this._el_179,' | +33 2 99 36 26 72',(null as any));
    this._el_186 = import4.createRenderElement(this.renderer,this._el_179,'br',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_187 = this.renderer.createText(this._el_179,'\n                    SIRET: 50874189900019 | ',(null as any));
    this._el_188 = import4.createRenderElement(this.renderer,this._el_179,'a',new import4.InlineArray2(2,'class','light-gray-text pointer'),(null as any));
    this._text_189 = this.renderer.createText(this._el_188,'',(null as any));
    this._text_190 = this.renderer.createText(this._el_179,'\n                    ',(null as any));
    this._text_191 = this.renderer.createText(this._el_179,'\n                    ',(null as any));
    this._text_192 = this.renderer.createText(this._el_179,'\n                ',(null as any));
    this._text_193 = this.renderer.createText(this._el_171,'\n                ',(null as any));
    this._text_194 = this.renderer.createText(this._el_171,'\n            ',(null as any));
    this._text_195 = this.renderer.createText(this._el_169,'\n        ',(null as any));
    this._text_196 = this.renderer.createText(this._el_167,'\n    ',(null as any));
    this._text_197 = this.renderer.createText(this._el_132,'\n    ',(null as any));
    this._text_198 = this.renderer.createText(this._el_132,'\n    ',(null as any));
    this._el_199 = import4.createRenderElement(this.renderer,this._el_132,'a',new import4.InlineArray4(4,'class','scrollToTop','href','javascript:;'),(null as any));
    this._el_200 = import4.createRenderElement(this.renderer,this._el_199,'i',new import4.InlineArray2(2,'class','fa fa-angle-up'),(null as any));
    this._text_201 = this.renderer.createText(this._el_132,'\n    ',(null as any));
    this._text_202 = this.renderer.createText(this._el_132,'\n',(null as any));
    this._text_203 = this.renderer.createText(this._el_3,'\n',(null as any));
    this._text_204 = this.renderer.createText(this._el_3,'\n\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_16,'click',this.eventHandler(this._handle_click_16_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_25,'click',this.eventHandler(this._handle_click_25_0.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_46,'click',this.eventHandler(this._handle_click_46_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_97,'click',this.eventHandler(this._handle_click_97_0.bind(this)));
    this._pipe_intl_0 = new import27.IntlPipe();
    this._pipe_intl_0_0 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_4:Function = this.renderer.listen(this._el_104,'click',this.eventHandler(this._handle_click_104_0.bind(this)));
    this._pipe_intl_0_1 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_5:Function = this.renderer.listen(this._el_111,'click',this.eventHandler(this._handle_click_111_0.bind(this)));
    this._pipe_intl_0_2 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_6:Function = this.renderer.listen(this._el_117,'click',this.eventHandler(this._handle_click_117_0.bind(this)));
    this._pipe_intl_0_3 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_7:Function = this.renderer.listen(this._el_129,'activate',this.eventHandler(this._handle_activate_129_0.bind(this)));
    const subscription_0:any = this._RouterOutlet_129_5.context.activateEvents.subscribe(this.eventHandler(this._handle_activate_129_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_188,'click',this.eventHandler(this._handle_click_188_0.bind(this)));
    this._pipe_intl_0_4 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this.init(([] as any[]),[
      this._text_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._text_33,
      this._anchor_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._anchor_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._text_69,
      this._text_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._text_78,
      this._el_79,
      this._text_80,
      this._el_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._text_85,
      this._text_86,
      this._text_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._el_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._text_99,
      this._text_100,
      this._text_101,
      this._el_102,
      this._text_103,
      this._el_104,
      this._text_105,
      this._text_106,
      this._text_107,
      this._text_108,
      this._el_109,
      this._text_110,
      this._el_111,
      this._text_112,
      this._text_113,
      this._text_114,
      this._el_115,
      this._text_116,
      this._el_117,
      this._text_118,
      this._text_119,
      this._text_120,
      this._text_121,
      this._text_122,
      this._text_123,
      this._text_124,
      this._text_125,
      this._text_126,
      this._text_127,
      this._text_128,
      this._el_129,
      this._text_130,
      this._text_131,
      this._el_132,
      this._text_133,
      this._el_134,
      this._text_135,
      this._el_136,
      this._text_137,
      this._el_138,
      this._text_139,
      this._el_140,
      this._el_141,
      this._text_142,
      this._el_143,
      this._el_144,
      this._text_145,
      this._text_146,
      this._text_147,
      this._el_148,
      this._el_149,
      this._text_150,
      this._el_151,
      this._el_152,
      this._text_153,
      this._text_154,
      this._text_155,
      this._el_156,
      this._el_157,
      this._text_158,
      this._el_159,
      this._el_160,
      this._text_161,
      this._text_162,
      this._text_163,
      this._text_164,
      this._text_165,
      this._text_166,
      this._el_167,
      this._text_168,
      this._el_169,
      this._text_170,
      this._el_171,
      this._text_172,
      this._text_173,
      this._el_174,
      this._text_175,
      this._text_176,
      this._text_177,
      this._text_178,
      this._el_179,
      this._text_180,
      this._el_181,
      this._text_182,
      this._el_183,
      this._text_184,
      this._text_185,
      this._el_186,
      this._text_187,
      this._el_188,
      this._text_189,
      this._text_190,
      this._text_191,
      this._text_192,
      this._text_193,
      this._text_194,
      this._text_195,
      this._text_196,
      this._text_197,
      this._text_198,
      this._el_199,
      this._el_200,
      this._text_201,
      this._text_202,
      this._text_203,
      this._text_204
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import33.CookieConsentComponent) && (5 === requestNodeIndex))) { return this._CookieConsentComponent_5_4.context; }
    if (((token === import28.TemplateRef) && (34 === requestNodeIndex))) { return this._TemplateRef_34_5; }
    if (((token === import34.NgIf) && (34 === requestNodeIndex))) { return this._NgIf_34_6.context; }
    if (((token === import22.NotificationService) && ((53 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._NotificationService_53_4; }
    if (((token === import35.CartWidgetComponent) && ((53 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._CartWidgetComponent_53_5.context; }
    if (((token === import28.TemplateRef) && (60 === requestNodeIndex))) { return this._TemplateRef_60_5; }
    if (((token === import36.NgFor) && (60 === requestNodeIndex))) { return this._NgFor_60_6.context; }
    if (((token === import28.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import36.NgFor) && (65 === requestNodeIndex))) { return this._NgFor_65_6.context; }
    if (((token === import37.NgClass) && ((102 <= requestNodeIndex) && (requestNodeIndex <= 107)))) { return this._NgClass_102_3.context; }
    if (((token === import37.NgClass) && ((109 <= requestNodeIndex) && (requestNodeIndex <= 113)))) { return this._NgClass_109_3.context; }
    if (((token === import37.NgClass) && ((115 <= requestNodeIndex) && (requestNodeIndex <= 119)))) { return this._NgClass_115_3.context; }
    if (((token === import38.RouterOutlet) && (129 === requestNodeIndex))) { return this._RouterOutlet_129_5.context; }
    if (((token === import39.LanguageRoutingComponent) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 204)))) { return this._LanguageRoutingComponent_3_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this._LanguageRoutingComponent_3_3.detectChangesInInputProps(this,this._el_3,throwOnChange);
    const currVal_5_0_0:any = this._LanguageRoutingComponent_3_3.context.currentLanguage;
    this._CookieConsentComponent_5_4.check_language(currVal_5_0_0,throwOnChange,false);
    this._CookieConsentComponent_5_4.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_34_0_0:any = this.context.nodeLoading;
    this._NgIf_34_6.check_ngIf(currVal_34_0_0,throwOnChange,false);
    this._NgIf_34_6.detectChangesInInputProps(this,this._anchor_34,throwOnChange);
    const currVal_53_0_0:any = this._LanguageRoutingComponent_3_3.context.currentLanguage;
    this._CartWidgetComponent_53_5.check_language(currVal_53_0_0,throwOnChange,false);
    const currVal_53_0_1:any = ((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.CART.WIDGET);
    this._CartWidgetComponent_53_5.check_labels(currVal_53_0_1,throwOnChange,false);
    this._CartWidgetComponent_53_5.detectChangesInInputProps(this,this._el_53,throwOnChange);
    const currVal_60_0_0:any = ((this.context.config.data == (null as any))? (null as any): this.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_60_6.check_ngForOf(currVal_60_0_0,throwOnChange,false);
    this._NgFor_60_6.detectChangesInInputProps(this,this._anchor_60,throwOnChange);
    const currVal_65_0_0:any = ((this.context.config.data == (null as any))? (null as any): this.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_65_6.check_ngForOf(currVal_65_0_0,throwOnChange,false);
    this._NgFor_65_6.detectChangesInInputProps(this,this._anchor_65,throwOnChange);
    const currVal_102_0_0:any = this._map_228(this.context.isCurrent('/catalogue'));
    this._NgClass_102_3.check_ngClass(currVal_102_0_0,throwOnChange,false);
    this._NgClass_102_3.detectChangesInInputProps(this,this._el_102,throwOnChange);
    const currVal_109_0_0:any = this._map_231(this.context.isCurrent('/writings'));
    this._NgClass_109_3.check_ngClass(currVal_109_0_0,throwOnChange,false);
    this._NgClass_109_3.detectChangesInInputProps(this,this._el_109,throwOnChange);
    const currVal_115_0_0:any = this._map_234(this.context.isCurrent('/about'));
    this._NgClass_115_3.check_ngClass(currVal_115_0_0,throwOnChange,false);
    this._NgClass_115_3.detectChangesInInputProps(this,this._el_115,throwOnChange);
    this._RouterOutlet_129_5.detectChangesInInputProps(this,this._el_129,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LanguageRoutingComponent_3_3.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this._CookieConsentComponent_5_4.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._CartWidgetComponent_53_5.detectChangesInHostProps(this,this._el_53,throwOnChange);
    valUnwrapper.reset();
    const currVal_225:any = import4.interpolate(1,'\n                            ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.HOME),this._LanguageRoutingComponent_3_3.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_225,currVal_225))) {
      this.renderer.setText(this._text_98,currVal_225);
      this._expr_225 = currVal_225;
    }
    this._NgClass_102_3.detectChangesInHostProps(this,this._el_102,throwOnChange);
    valUnwrapper.reset();
    const currVal_229:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.CATALOGUE),this._LanguageRoutingComponent_3_3.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_229,currVal_229))) {
      this.renderer.setText(this._text_105,currVal_229);
      this._expr_229 = currVal_229;
    }
    this._NgClass_109_3.detectChangesInHostProps(this,this._el_109,throwOnChange);
    valUnwrapper.reset();
    const currVal_232:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.WRITINGS),this._LanguageRoutingComponent_3_3.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_232,currVal_232))) {
      this.renderer.setText(this._text_112,currVal_232);
      this._expr_232 = currVal_232;
    }
    this._NgClass_115_3.detectChangesInHostProps(this,this._el_115,throwOnChange);
    valUnwrapper.reset();
    const currVal_235:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.ABOUT),this._LanguageRoutingComponent_3_3.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_235,currVal_235))) {
      this.renderer.setText(this._text_118,currVal_235);
      this._expr_235 = currVal_235;
    }
    this._RouterOutlet_129_5.detectChangesInHostProps(this,this._el_129,throwOnChange);
    const currVal_237:any = import4.interpolate(1,'\n                    © 2009-',this.context.currentYear,' Forgotten Records.\n                ');
    if (import4.checkBinding(throwOnChange,this._expr_237,currVal_237)) {
      this.renderer.setText(this._text_175,currVal_237);
      this._expr_237 = currVal_237;
    }
    valUnwrapper.reset();
    const currVal_238:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.LEGAL_MENTIONS),this._LanguageRoutingComponent_3_3.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_238,currVal_238))) {
      this.renderer.setText(this._text_189,currVal_238);
      this._expr_238 = currVal_238;
    }
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CookieConsentComponent_5_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._RouterOutlet_129_5.context.ngOnDestroy();
  }
  private _handle_click_16_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_16_0:any = ((<any>this.context.utils.lLink('',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_16_0);
  }
  private _handle_click_25_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_25_0:any = ((<any>this.context.utils.lLink('',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_25_0);
  }
  private _handle_click_46_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_46_0:any = ((<any>this.context.onSearchClick('catalogue',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_46_0);
  }
  private _handle_click_97_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_97_0:any = ((<any>this.context.onMenuClick('',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_97_0);
  }
  private _handle_click_104_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_104_0:any = ((<any>this.context.onMenuClick('catalogue',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_104_0);
  }
  private _handle_click_111_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_111_0:any = ((<any>this.context.onMenuClick('writings',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_111_0);
  }
  private _handle_click_117_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_117_0:any = ((<any>this.context.onMenuClick('page/about',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_117_0);
  }
  private _handle_activate_129_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_129_0:any = ((<any>this.context.onActivate($event)) !== false);
    return (true && pd_129_0);
  }
  private _handle_click_188_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_188_0:any = ((<any>this.context.utils.lLink('page/legal',this._LanguageRoutingComponent_3_3.context.currentLanguage)) !== false);
    return (true && pd_188_0);
  }
}
export function viewFactory_FrontRootComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.FrontRootComponent> {
  if ((renderType_FrontRootComponent === (null as any))) { (renderType_FrontRootComponent = viewUtils.createRenderComponentType('',0,import17.ViewEncapsulation.None,styles_FrontRootComponent,{})); }
  return new _View_FrontRootComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_FrontRootComponent1 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _LoadingIndicator_0_4:import40.Wrapper_LoadingIndicator;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_FrontRootComponent1,renderType_FrontRootComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'loading-indicator',new import4.InlineArray4(4,'class','app-loading','color','#8f2424'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import40.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LoadingIndicator_0_4 = new import40.Wrapper_LoadingIndicator();
    this._appEl_0.initComponent(this._LoadingIndicator_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LoadingIndicator_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import41.LoadingIndicator) && (0 === requestNodeIndex))) { return this._LoadingIndicator_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = '#8f2424';
    this._LoadingIndicator_0_4.check_color(currVal_0_0_0,throwOnChange,false);
    this._LoadingIndicator_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_FrontRootComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_FrontRootComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_FrontRootComponent2 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _LanguageSelectorComponent_0_4:import42.Wrapper_LanguageSelectorComponent;
  _text_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_FrontRootComponent2,renderType_FrontRootComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',new import4.InlineArray4(4,'class','language-select','language-selector',''),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import42.viewFactory_LanguageSelectorComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LanguageSelectorComponent_0_4 = new import42.Wrapper_LanguageSelectorComponent(this.parent.parentInjector.get(import8.ConfigService),this.parent.parentInjector.get(import12.Location),this.parent.parentInjector.get(import14.Router),this.parent.parentInjector.get(import16.UtilsService),this.parent.parentInjector.get(import10.CookieService));
    this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n                        ',(null as any));
    compView_0.create(this._LanguageSelectorComponent_0_4.context,([] as any[]),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'onLanguageSelect',this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
    const subscription_0:any = this._LanguageSelectorComponent_0_4.context.onLanguageSelect.subscribe(this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import43.LanguageSelectorComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._LanguageSelectorComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = (<_View_FrontRootComponent0>this.parent)._LanguageRoutingComponent_3_3.context.resourcePath;
    this._LanguageSelectorComponent_0_4.check_resourcePath(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = (<_View_FrontRootComponent0>this.parent)._LanguageRoutingComponent_3_3.context.currentLanguage;
    this._LanguageSelectorComponent_0_4.check_currentLanguage(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = false;
    this._LanguageSelectorComponent_0_4.check_displayCurrent(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = this.context.$implicit;
    this._LanguageSelectorComponent_0_4.check_language(currVal_0_0_3,throwOnChange,false);
    const currVal_0_0_4:any = ((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.LANGUAGE_LOCALE);
    this._LanguageSelectorComponent_0_4.check_labels(currVal_0_0_4,throwOnChange,false);
    this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_onLanguageSelect_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>(<_View_FrontRootComponent0>this.parent)._LanguageRoutingComponent_3_3.context.onSelect($event)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_FrontRootComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_FrontRootComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_FrontRootComponent3 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _LanguageSelectorComponent_0_4:import42.Wrapper_LanguageSelectorComponent;
  _text_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_FrontRootComponent3,renderType_FrontRootComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',new import4.InlineArray4(4,'class','language-select','language-selector',''),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import42.viewFactory_LanguageSelectorComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LanguageSelectorComponent_0_4 = new import42.Wrapper_LanguageSelectorComponent(this.parent.parentInjector.get(import8.ConfigService),this.parent.parentInjector.get(import12.Location),this.parent.parentInjector.get(import14.Router),this.parent.parentInjector.get(import16.UtilsService),this.parent.parentInjector.get(import10.CookieService));
    this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n                        ',(null as any));
    compView_0.create(this._LanguageSelectorComponent_0_4.context,([] as any[]),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'onLanguageSelect',this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
    const subscription_0:any = this._LanguageSelectorComponent_0_4.context.onLanguageSelect.subscribe(this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import43.LanguageSelectorComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._LanguageSelectorComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = (<_View_FrontRootComponent0>this.parent)._LanguageRoutingComponent_3_3.context.resourcePath;
    this._LanguageSelectorComponent_0_4.check_resourcePath(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = (<_View_FrontRootComponent0>this.parent)._LanguageRoutingComponent_3_3.context.currentLanguage;
    this._LanguageSelectorComponent_0_4.check_currentLanguage(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = false;
    this._LanguageSelectorComponent_0_4.check_displayCurrent(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = this.context.$implicit;
    this._LanguageSelectorComponent_0_4.check_language(currVal_0_0_3,throwOnChange,false);
    const currVal_0_0_4:any = ((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.LANGUAGE_LOCALE);
    this._LanguageSelectorComponent_0_4.check_labels(currVal_0_0_4,throwOnChange,false);
    this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_onLanguageSelect_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>(<_View_FrontRootComponent0>this.parent)._LanguageRoutingComponent_3_3.context.onSelect($event)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_FrontRootComponent3(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_FrontRootComponent3(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/root.component.ngfactory.ts